import React, { Component } from 'react';
import styled from 'styled-components';
import mainLogo from '../logos/Hauptlogo.png';

class JTitle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            x: 0,
            y: 0,
            height: 0,
            width: 0,
            hidden: false
        };
        this.resize = this.resize.bind(this);
        this.scroll = this.scroll.bind(this);
    }


    render() {

        return (
            <JSection id='section' >
                <JHead>
                    <JLogo id='logo'>
                        <JImg width={'' + this.state.width * 0.65} src={mainLogo} alt='' />
                    </JLogo>

                </JHead>
            </JSection>
        );
    }



    resize() {
        this.setState({
            height: document.getElementById('section').clientHeight,
            width: document.getElementById('section').clientWidth
        });
    }

    scroll() {
        if (document.getElementById('logo').getBoundingClientRect().top > 260) {
            //  document.getElementById('logo').style.transform = 'scale(1)';
            this.setState({
                hidden: false,
            });
        }

        if (document.getElementById('logo').getBoundingClientRect().top < 50) {
            this.setState({
                hidden: true,
            })
        }
    }

    componentDidMount() {
        this.resize();
        this.scroll();
        window.addEventListener("resize", this.resize);
        window.addEventListener("scroll", this.scroll);
        this.setState({
            height: document.getElementById('section').clientHeight,
            width: document.getElementById('section').clientWidth
        });
    }

    componentWillUnmount() {
        this.resize();
        this.scroll();
        window.removeEventListener("resize", this.resize);
        window.removeEventListener("scroll", this.scroll);
    }
}


const JSection = styled.div`
    width: 100%;
    height: calc(50vh);
`;

const JHead = styled.div`
width: 100%;
position: absolute;
top: calc(30vh);
text-align: center;
`;

const JLogo = styled.p`
`;

const JImg = styled.img`
    max-width: 1000px
`;

export default JTitle;